import { useActionState, useEffect } from "react";
import Input from "../../../../components/input";
import Label from "../../../../components/label";
import IconButton from "../../../../components/icon-button";
import { PlusIcon } from "@heroicons/react/24/outline";
import { createTemporaryIllness, State } from "../actions";
import FormError from "../../../../components/form-error";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function TemporaryIllnessCreateForm(){
  const navigate = useNavigate();
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
    },
  };
  const [state, formAction, isPending] = useActionState(createTemporaryIllness, initialState);

  useEffect(() => {
    if (state.success) {
      toast.success("Temporary illness created successfully");
      navigate(`/admin/temporary-illnesses?reload=${Date.now()}`);
    }
  }, [state.success]);

  return (
    <form className="flex flex-col" action={formAction}>
      <div className="flex flex-1 gap-2 items-end">
        <div className="flex-1">
          <Label htmlFor="name">Name</Label>
          <Input id="name" name="name" type="text" placeholder="Enter name" required />
        </div>
        <IconButton label="Add" icon={PlusIcon} loading={isPending} />
      </div>
      <FormError id="name-error" message={state.errors?.name} />
    </form>
  );
}
